import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';

/**
 * Service to Track Analytics Events.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
@Injectable()
export class TrackingService {
    private previousUrl: string;

    public emitEvent(eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null) {
        if (!environment.production) {
            return;
        }
        ga('send', 'event', {
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            eventValue: eventValue
        });
    }

    public sendPageview(url): void {
        if (!environment.production) {
            return;
        }
        if (url === this.previousUrl) {
            return;
        }
        this.previousUrl = url;
        ga('send', 'pageview', url);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tracking/google-analytics-events.service.ts